function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIhgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 929.239 483.202",
    style: {
      enableBackground: "new 0 0 929.239 483.202"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Guides"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none"
    },
    width: 117.168,
    height: 117.168
  }), /*#__PURE__*/React.createElement("rect", {
    x: 812.059,
    y: 366.035,
    style: {
      fill: "none"
    },
    width: 117.168,
    height: 117.168
  })), /*#__PURE__*/React.createElement("g", {
    id: "Brandmark"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#323D45"
    },
    d: "M669.273,121.04c-4.802,0-8.598,3.833-8.598,8.596c0,4.841,3.835,8.52,8.598,8.52 c4.802,0,8.596-3.718,8.596-8.559C677.869,124.834,674.151,121.04,669.273,121.04z M669.273,136.763 c-3.95,0-7.048-2.866-7.048-7.126c0-4.22,2.944-7.202,7.048-7.202c4.105,0,7.048,2.944,7.048,7.163 C676.321,133.819,673.26,136.763,669.273,136.763z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#323D45"
    },
    d: "M672.564,127.855v-0.039c0-1.743-1.278-2.556-3.253-2.556h-2.982v8.481h1.859v-3.291h0.891 l2.052,3.291h1.935l-2.246-3.6C671.827,129.83,672.564,129.134,672.564,127.855z M670.744,127.932 c0,0.813-0.504,1.239-1.472,1.239h-1.085v-2.479h1.085c0.929,0,1.472,0.31,1.472,1.202V127.932z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#323D45"
    },
    points: "458.469,182.561 380.359,182.561 380.359,119.548 358.913,119.548 358.913,262.784  380.359,262.784 380.359,197.344 458.469,197.344 458.469,262.784 480.092,262.784 480.092,119.548 458.469,119.548  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.951,
    y: 119.548,
    style: {
      fill: "#323D45"
    },
    width: 21.407,
    height: 143.236
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#323D45"
    },
    d: "M604.439,265.165c23.15,0,41.108-8.869,50.846-11.682v-59.628h-21.639v55.516 c-6.057,4.112-16.225,7.356-27.696,7.356c-33.534,0-56.471-29.644-56.471-67.074c0-35.27,20.122-64.261,53.662-64.261 c23.15,0,36.35,10.818,46.084,22.935h1.083v-24.883c-6.925-1.73-26.181-6.275-46.303-6.275c-48.682,0-78.326,35.485-78.326,74.433 C525.679,234.222,557.702,265.165,604.439,265.165z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#323D45"
    },
    points: "152.279,344.069 122.262,344.069 122.262,326.376 117.167,326.376 117.167,365.542  122.262,365.542 122.262,348.177 152.279,348.177 152.279,365.542 157.374,365.542 157.374,326.376 152.279,326.376  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#323D45"
    },
    d: "M194.504,325.884c-15.612,0-25.745,8.764-25.745,19.884v0.438 c0,10.955,10.134,19.829,25.909,19.829c15.447,0,25.581-8.874,25.581-19.938v-0.439 C220.249,334.648,210.115,325.884,194.504,325.884z M214.936,346.042c0,9.421-7.778,15.995-20.267,15.995 c-12.161,0-20.596-6.464-20.596-15.885v-0.438c0-9.257,7.395-15.94,20.432-15.94c12.927,0,20.431,7.121,20.431,15.83V346.042z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#323D45"
    },
    points: "225.061,330.32 241.166,330.32 241.166,365.542 246.26,365.542 246.26,330.32  262.364,330.32 262.364,326.376 225.061,326.376  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#323D45"
    },
    points: "277.641,347.465 301.14,347.465 301.14,343.522 277.641,343.522 277.641,330.32  305.522,330.32 305.522,326.376 272.547,326.376 272.547,365.542 306.837,365.542 306.837,361.598 277.641,361.598  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#323D45"
    },
    points: "322.551,326.376 317.457,326.376 317.457,365.542 347.803,365.542 347.803,361.598  322.551,361.598  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#323D45"
    },
    d: "M374.857,343.028c-10.955-1.259-13.529-3.286-13.529-6.792c0-3.944,3.56-6.464,11.831-6.464 c7.614,0,11.887,1.808,13.092,6.902h4.656c-1.041-7.176-7.559-10.791-17.748-10.791c-10.298,0-16.597,4.437-16.597,10.462 c0,7.011,6.025,9.585,16.816,10.845c10.737,1.26,14.187,2.739,14.187,7.34c0,4.766-4.71,7.614-13.091,7.614 c-10.462,0-14.133-3.725-14.955-8.545h-4.984c0.986,6.902,6.793,12.434,19.939,12.434c11.338,0,18.022-4.875,18.022-11.668 C392.496,346.644,386.361,344.343,374.857,343.028z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#323D45"
    },
    d: "M523.003,338.099v-0.22c0-8.271-7.34-11.503-16.05-11.503h-18.624v39.166h5.094v-15.885h12.544 l14.023,15.885h6.135l-14.352-16.269C517.251,348.287,523.003,344.891,523.003,338.099z M493.424,345.822v-15.556h13.859 c6.19,0,10.627,2.081,10.627,7.668v0.22c0,4.984-4.108,7.668-10.627,7.668H493.424z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#323D45"
    },
    points: "541.291,347.465 564.79,347.465 564.79,343.522 541.291,343.522 541.291,330.32  569.172,330.32 569.172,326.376 536.197,326.376 536.197,365.542 570.487,365.542 570.487,361.598 541.291,361.598  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#323D45"
    },
    d: "M598.361,343.028c-10.955-1.259-13.53-3.286-13.53-6.792c0-3.944,3.561-6.464,11.832-6.464 c7.614,0,11.887,1.808,13.091,6.902h4.656c-1.041-7.176-7.559-10.791-17.747-10.791c-10.298,0-16.597,4.437-16.597,10.462 c0,7.011,6.025,9.585,16.816,10.845c10.736,1.26,14.187,2.739,14.187,7.34c0,4.766-4.71,7.614-13.092,7.614 c-10.462,0-14.132-3.725-14.954-8.545h-4.984c0.986,6.902,6.792,12.434,19.938,12.434c11.339,0,18.022-4.875,18.022-11.668 C616,346.644,609.865,344.343,598.361,343.028z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#323D45"
    },
    d: "M650.502,325.884c-15.612,0-25.745,8.764-25.745,19.884v0.438 c0,10.955,10.134,19.829,25.909,19.829c15.447,0,25.581-8.874,25.581-19.938v-0.439 C676.248,334.648,666.113,325.884,650.502,325.884z M670.934,346.042c0,9.421-7.778,15.995-20.267,15.995 c-12.161,0-20.596-6.464-20.596-15.885v-0.438c0-9.257,7.395-15.94,20.432-15.94c12.927,0,20.431,7.121,20.431,15.83V346.042z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#323D45"
    },
    d: "M722.524,338.099v-0.22c0-8.271-7.34-11.503-16.05-11.503H687.85v39.166h5.094v-15.885h12.544 l14.023,15.885h6.135l-14.352-16.269C716.773,348.287,722.524,344.891,722.524,338.099z M692.944,345.822v-15.556h13.859 c6.19,0,10.627,2.081,10.627,7.668v0.22c0,4.984-4.108,7.668-10.627,7.668H692.944z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#323D45"
    },
    points: "730.788,330.32 746.893,330.32 746.893,365.542 751.987,365.542 751.987,330.32  768.091,330.32 768.091,326.376 730.788,326.376  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#323D45"
    },
    d: "M794.433,343.028c-10.955-1.259-13.529-3.286-13.529-6.792c0-3.944,3.56-6.464,11.831-6.464 c7.614,0,11.887,1.808,13.092,6.902h4.656c-1.041-7.176-7.559-10.791-17.748-10.791c-10.298,0-16.597,4.437-16.597,10.462 c0,7.011,6.025,9.585,16.816,10.845c10.737,1.26,14.187,2.739,14.187,7.34c0,4.766-4.71,7.614-13.091,7.614 c-10.462,0-14.133-3.725-14.955-8.545h-4.984c0.986,6.902,6.793,12.434,19.939,12.434c11.338,0,18.022-4.875,18.022-11.668 C812.072,346.644,805.937,344.343,794.433,343.028z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#323D45"
    },
    d: "M458.35,345.331h-4.206l-6.166,9.256l-9.512-9.639c5.975-2.355,9.034-6.133,9.034-10.022 c0-5.257-3.967-9.091-9.894-9.091c-5.544,0-10.468,3.395-10.468,9.42c0,3.669,1.721,6.407,4.302,8.708 c-4.971,1.862-9.799,5.257-9.799,11.501c0,6.572,5.306,10.46,13.336,10.46c5.688,0,9.894-2.519,12.762-5.75l5.21,5.367h5.784 l-8.221-8.379L458.35,345.331z M431.249,335.309c0-3.888,2.772-5.86,6.261-5.86c3.776,0,5.927,2.355,5.927,5.367 c0,3.122-2.055,5.531-7.552,7.886C433.256,340.567,431.249,338.266,431.249,335.309z M435.072,362.144 c-5.784,0-8.938-2.683-8.938-6.955c0-4.655,3.394-7.229,8.03-8.927l11.28,11.556C443.103,360.337,439.661,362.144,435.072,362.144 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIhgIcon);
export default __webpack_public_path__ + "static/media/ihg-icon.0b76f4bba2b6cf89c0eaae030707654f.svg";
export { ForwardRef as ReactComponent };